import routes from './ecommerce.routes'

export const ecommerceModule = {
  routes
}
